import type { ComponentProps, ReactElement } from 'react';
import type React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { TabLink, TabLinks } from '@change-corgi/design-system-legacy/components/navigation';
import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';

import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC = () => {
	const {
		data: { showGuidesLink, urlBase, guides },
	} = usePageHeading();

	return (
		<div className="container mt-2 px-0">
			<DesignSystemLegacy theme={sunriseTheme}>
				<TabLinks
					selected={guides ? 'guides' : 'news'}
					sx={{
						li: {
							fontWeight: 400,
							color: 'sunrise.semantic.typography.weak',
							'&:has([data-active-link="true"])': {
								fontWeight: 700,
								color: 'sunrise.semantic.typography.interactive.default',
								borderColor: 'sunrise.semantic.stroke.selected',
							},
							'&:has(a:focus), &:has(a:active)': {
								fontWeight: 700,
								color: 'sunrise.semantic.typography.interactive.default',
								borderColor: 'sunrise.semantic.stroke.selected',
							},

							':hover': {
								color: 'sunrise.semantic.typography.interactive.default',
								borderColor: 'sunrise.semantic.stroke.selected',
								cursor: 'pointer',
								backgroundColor: 'sunrise.semantic.fill.hover',
							},
						},
					}}
				>
					{/* using forceMode=external to avoid loading indicator when switching tabs
				this would b unnecessary if those pages had different paths */}
					<TabLink name="news" to={urlBase} forceMode="external" data-active-link={!guides}>
						<Translate value="fe.components.news_header.news" />
					</TabLink>
					{/* FIXME update types of Tabs to allow for conditional tab links */}
					{
						// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
						(showGuidesLink ? (
							// eslint-disable-next-line @change-corgi/require-data-qa-attribute
							<TabLink name="guides" to={`${urlBase}?category=guides`} forceMode="external" data-active-link={!!guides}>
								<Translate value="fe.components.footer.guides" />
							</TabLink>
						) : null) as unknown as ReactElement<ComponentProps<typeof TabLink>>
					}
				</TabLinks>
			</DesignSystemLegacy>
		</div>
	);
};
